// GAVION task actions: « Appeler », « Courriel », « Noter », « Contexte » show on the /tasks page only. Task.tsx is
// shared with the compagnie/contact/deal pages, where the same actions already sit in the page header.
import { createContext, useContext } from "react";

export const TaskActionsScope = createContext(false);

/** True inside <TaskActionsScope.Provider value>, i.e. on the tasks page. */
export const useTaskActionsEnabled = () => useContext(TaskActionsScope);
